import { Component, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { PostsService } from 'src/app/services/posts/posts.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment'
import { PostModalComponent } from './post-modal/post-modal.component';

@Component({
  selector: 'app-posts',
  imports: [SpinnerComponent, CommonModule, FormsModule],
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css']
})
export class PostsComponent {

  // შეცვლილია: ახლა data არის object ტიპის
  data: { items: any[], pagination: any } = { items: [], pagination: null };
  load = false;
  loaddata = false;
  currentLang = 'ge';
  loadDeleteId: number | null = null;

  page: number = 1;
  perPage: number = 20;

  selectedItems: any[] = [];
  selectedItem: number = 161;

  @ViewChild('scrollTarget') scrollTarget: any;

  selectedPost: any = null;
  @ViewChild('postFormModal') pageFormModalTemplate!: TemplateRef<any>;
  @ViewChild('postCatalogFormModal') postCatalogFormModal!: TemplateRef<any>;

  // domain  = environment.apiDomain;
  domain  = 'https://sca.ge/';
  search: string = '';

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private langService: LanguageService,
    private ToastrService: ToastrService,
    private PostsService: PostsService,
    private modalService: NgbModal,
  ){
    this.currentLang = this.langService.getLanguage();

    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
      this.getListPages();
    });

    this.getListPages();
  }

  // Dropdown ჩამოტანა list ტიპის გვერდების
  getListPages() {
    this.load = true;
    this.PostsService.getListPages().subscribe(
      (res: any) => {

        this.load = false;
        this.selectedItems = res.data || [];
        console.log(1, this.selectedItems)
        if (this.selectedItems.length > 0) {
          this.selectedItem = 161;
          this.getPageByItems();
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      (err: any) => {
        console.error(err);
        this.load = false;
      }
    );
  }

  // სიახლეების ჩამოტანა menu_page-ს მიხედვით
  getPageByItems() {
    if (!this.selectedItem) return;

    this.loaddata = true;

    const params = {
      menu_page: this.selectedItem,
      lang: this.currentLang,
      page: this.page,        // ✅ რეალური pagination
      limit: this.perPage,    // ✅ რამდენი ჩანაწერი თითო გვერდზე
      q: this.search || ''
    };

    this.PostsService.getPageByItems(params).subscribe(
      (res: any) => {

        this.data.items = res.items || [];

        // ✅ პირდაპირ Laravel-ის pagination meta
        this.data.pagination = res.pagination;

        this.loaddata = false;

        setTimeout(() => {
          if (this.scrollTarget?.nativeElement) {
            this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth' });
          }
        }, 50);
      },
      (err: any) => {
        console.error(err);
        this.loaddata = false;
      }
    );
  }

  // Dropdown არჩევისას
  onMenuChange() {
    this.page = 1;
    this.getPageByItems();
  }

  // Pagination
  changePage(newPage: number) {
    if (!this.data.pagination) return;

    if (
      newPage < 1 ||
      newPage > this.data.pagination.last_page
    ) return;

    this.page = newPage;
    this.getPageByItems();
  }

  // Sorting
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    if (this.data.items?.length) {
      this.data.items = [...this.data.items].sort((a, b) => {
        const valueA = a[column];
        const valueB = b[column];
        if (valueA == null) return 1;
        if (valueB == null) return -1;
        if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
        if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }
  }

  getFullImageUrl(imagePath: string): string {
    if (!imagePath) return '';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
    // return `${this.domain}${imagePath.replace(/^\/+/, '')}`;
    return `${this.domain}${imagePath.replace(/^\/+/, '')}`;
  }

  // Open modals
  openPost() {
    this.selectedPost = null;

    const modalRef = this.modalService.open(PostModalComponent, { size: 'lg', windowClass: 'custom-modal' });

    modalRef.componentInstance.selectedItem = this.selectedItem;
    modalRef.componentInstance.selectedItems = this.selectedItems;

    // ✅ closeModal event-ის დაჭერა
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.getPageByItems();   // სიახლეების განახლება
      this.selectedPost = null;
    });
  }

  edit(data: any) {
    this.selectedPost = data;

    const modalRef = this.modalService.open(PostModalComponent, { size: 'lg', windowClass: 'custom-modal' });


    modalRef.componentInstance.initialData = data;
  
    modalRef.componentInstance.selectedItem = this.selectedItem;
    modalRef.componentInstance.selectedItems = this.selectedItems;

    // ✅ closeModal event-ის დაჭერა
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
      this.getPageByItems();   // სიახლეების განახლება
      this.selectedPost = null;
    });
  }

  onPostSaved() {
    this.modalService.dismissAll();
    this.getPageByItems();
    this.selectedPost = null;
  }

  onCloseModal() {
    this.modalService.dismissAll();
  }

  onCatalogSaved() {
    this.modalService.dismissAll();
    this.getPageByItems();
    this.selectedPost = null;
  }

  delete(data: any, source: string) {
    if (confirm(`დარწმუნებული ხარ რომ გინდა წაშლა: "${data.title}"?`)) {
      this.loadDeleteId = data.id;
      this.PostsService.delete(data.id, source).subscribe({
        next: () => {
          this.ToastrService.success('წარმატებით წაიშალა');
          this.getPageByItems();
          this.loadDeleteId = null;
        },
        error: (err: any) => {
          console.error(err);
          this.ToastrService.error('შეცდომა წაშლისას');
          this.loadDeleteId = null;
        }
      });
    }
  }

  // Helpers for selected menu
  get selectedMenuType(): number {
    const found = this.selectedItems.find(item => item.slug === this.selectedItem);
    return found?.menutype ?? 0;
  }

  get selectedMenuSource(): string {
    const found = this.selectedItems.find(item => item.slug === this.selectedItem);
    return found?.source ?? '';
  }

}